
import { Select } from 'antd';
import { Observer } from 'mobx-react';
import React, { useState } from 'react';
import { ArrowDownIcon } from '../../../../assets/icons/common/common-icons';
import { useStore } from '../../../../modules/app/data/root.store';
import { SelectEmptyStateMessage, SelectEmptyStateWrapper } from '../../../../modules/user/components/CustomClassList/EditCustomClass.styles';
import { HoldingEntityImageTile, HoldingEntitySelectOptionText } from '../../../../modules/user/components/HoldingEntityList/EditHoldingEntity.styles';
import { holdingEntityBackgroundColors } from '../../../../modules/user/components/HoldingEntityList/background-colors/holding-entity-background-colors';
import { colors } from '../../../styles/theme.styles';
import { isNullOrUndefinedOrEmptyString } from '../../../utils/object.utils';
import { ModifiedSelectClearIcon } from '../../ModifiedSelectClearIcon/ModifiedSelectClearIcon';

const { Option } = Select;

export function BeneficiarySelect(props) {
    const { inputKey, handleChange, disabled, value, scrollContainerId, defaultValue, allowClear } = props;

    const { metadataStore, uiStore } = useStore();
    const [searchInput, setSearchInput] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const handleSelectClick = () => {
        setIsOpen(!isOpen);
        setSearchInput(''); // Clear the search input
        if (value) {
            handleChange(null); // Clear the selected value
        }
    };

    const bgColor = holdingEntityBackgroundColors.find((bgColor) => bgColor === value?.colorCode) || {};

    return (<Observer>{() => (
        <Select
            value={isOpen ? null : value} // Show the cleared state when the dropdown is open
            name={inputKey}
            showSearch
            open={isOpen}
            onClick={handleSelectClick}
            onBlur={() => setIsOpen(false)}
            searchValue={searchInput}
            onSearch={(val) => setSearchInput(val)}
            filterOption={(input, option) => option.value.toLowerCase().startsWith(input.toLowerCase())}
            
            disabled={disabled}
            allowClear={allowClear && !isNullOrUndefinedOrEmptyString(value)}
            clearIcon={allowClear ? <ModifiedSelectClearIcon /> : null}
            optionLabelProp='label'
            defaultValue={defaultValue}
            onChange={(val) => { handleChange(inputKey, val) }}
            dropdownClassName='formDisplayerDefaultSelect'
            getPopupContainer={() => scrollContainerId ? (document.getElementById(scrollContainerId) || document.body) : document.body}
            suffixIcon={<ArrowDownIcon />}
            notFoundContent={<SelectEmptyStateWrapper>
                <HoldingEntityImageTile
                    image={bgColor}
                    size={28}
                >
                    <HoldingEntitySvg />
                </HoldingEntityImageTile>
                <SelectEmptyStateMessage>No holding entities yet</SelectEmptyStateMessage>

            </SelectEmptyStateWrapper>}
            dropdownRender={menu => (<>
                {menu}
                <div
                 style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', borderTop: `1px solid ${colors.gray3}` }}
                 onMouseDown={(e) => e.stopPropagation()} // Prevent Select dropdown from closing
                 >
                    <a style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '8px', justifyContent: 'center', padding: '8px', color: '#2565E7', pointerEvents: 'auto', }} href={'/profile/preferences' + (uiStore.isDesktopView ? '?spt=entitiesManagement' : '/entities-management')} >Edit entities management list<ArrowLinkSvg /></a>
                </div>
            </>)}
        >
            {metadataStore.beneficiaries.map(beneficiary => {
                const bgColor = holdingEntityBackgroundColors.find((bgColor) => bgColor === beneficiary?.colorCode) || {};
                return (
                    <Option key={beneficiary.id} value={beneficiary.name} className='formDisplayerSelectWithDescriptionOption' label={
                        <div style={{ display: 'flex', flex: 1, alignItems: 'center', marginTop: '-1px', gap: '8px' }}>
                            <HoldingEntityImageTile
                                image={bgColor}
                                size={28}
                                borderRadius={2}
                            >
                                <HoldingEntitySvg />
                            </HoldingEntityImageTile>
                            <HoldingEntitySelectOptionText imgSize={28}>{beneficiary.name}</HoldingEntitySelectOptionText>
                        </div>}>
                        <div style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '8px' }}>
                            <HoldingEntityImageTile
                                image={bgColor}
                                size={32}
                                sizeDelta={12}
                                borderRadius={2}
                            >
                                <HoldingEntitySvg />
                            </HoldingEntityImageTile>
                            <HoldingEntitySelectOptionText imgSize={32}>{beneficiary.name}</HoldingEntitySelectOptionText>
                        </div>
                    </Option>
                )
            })}

            {searchInput !== '' && <Option key='addNew' value={searchInput} className='formDisplayerSelectWithDescriptionOption' label={
                <div style={{ display: 'flex', flex: 1, alignItems: 'center', marginTop: '-1px', gap: '8px' }}>
                    <HoldingEntityImageTile
                        image={colors.gray3}
                        size={28}
                        borderRadius={2}
                    >
                        <HoldingEntitySvg />
                    </HoldingEntityImageTile>
                    {searchInput}</div>}>
                <div style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '8px' }}>
                    <PlusIcon />
                    Add new "{searchInput}"</div>
            </Option>}
        </Select>
    )}</Observer>)
}


const ArrowLinkSvg = () => (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9675 8.875C10.9675 8.875 15.233 8.875 17.1652 8.875C17.1652 10.8072 17.1652 15.0727 17.1652 15.0727" stroke="#2565E7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.25 16.7969L16.8958 9.15103" stroke="#2565E7" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
)

const HoldingEntitySvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M13.25 0.25H0.34375V16.4375C0.34375 17.2832 1.02931 17.9688 1.875 17.9688H8.21875V16.6563H1.875C1.75419 16.6563 1.65625 16.5583 1.65625 16.4375V1.5625H13.25C13.3708 1.5625 13.4688 1.66044 13.4688 1.78125V7.57812H14.7812V1.78125C14.7812 0.935564 14.0957 0.25 13.25 0.25ZM10.1371 9.75679C10.1928 9.44765 9.98727 9.15192 9.67813 9.09626C9.36899 9.04059 9.07326 9.24608 9.01759 9.55522C8.96231 9.86224 8.856 10.1632 8.71247 10.4545C8.3978 10.3254 8.07545 10.3223 7.86032 10.3223C6.85282 10.3223 5.87455 10.682 5.07121 11.2456C4.4176 11.7041 3.6904 12.4909 3.7131 13.5577C3.71969 13.8671 3.81333 14.213 4.13644 14.4264C4.40229 14.6019 4.71557 14.6031 4.89686 14.599C5.61904 14.5826 6.26298 14.3216 6.82154 14.0124C7.59922 13.582 8.27396 12.9633 8.82687 12.3108L8.85687 12.2752C8.89985 12.3312 8.94531 12.3874 8.99352 12.4427C9.25658 12.7443 9.65932 13.0514 10.1368 13.1429C10.8157 13.2731 11.5578 13.3341 12.3196 13.0575C12.5834 12.9617 12.8637 12.8231 13.1042 12.7043C13.2119 12.6511 13.3116 12.6018 13.3983 12.5621C13.4321 12.5466 13.454 12.5368 13.4713 12.5298C13.545 12.5577 13.6351 12.6139 13.7655 12.7172C13.796 12.7413 13.8329 12.7718 13.8741 12.8058C13.9906 12.902 14.1417 13.0268 14.2809 13.1183C14.7659 13.4371 15.4162 13.6792 16.1247 13.4313C16.3476 13.3534 16.5551 13.2535 16.7332 13.1669L16.7653 13.1512C16.9382 13.0671 17.0837 12.9963 17.2321 12.9395L17.2321 12.9395C17.2323 12.9395 17.2344 12.9387 17.239 12.9373C17.244 12.9358 17.2509 12.9339 17.2607 12.9314C17.2768 12.9274 17.2904 12.9244 17.3099 12.9201L17.3463 12.9119L17.3466 12.9118C17.4123 12.897 17.541 12.8678 17.6695 12.8007C17.948 12.6554 18.0559 12.3118 17.9105 12.0334C17.7665 11.7574 17.4278 11.6489 17.1507 11.7885L17.1496 11.7888C17.1444 11.7903 17.1286 11.7949 17.095 11.8025L17.0764 11.8067L17.0763 11.8067C17.0517 11.8122 17.0167 11.82 16.9858 11.8277C16.9419 11.8386 16.8859 11.8541 16.8258 11.8771C16.6286 11.9525 16.4399 12.0444 16.2769 12.1239L16.2768 12.1239L16.2357 12.1439C16.0546 12.232 15.9018 12.3042 15.7491 12.3577C15.5119 12.4406 15.2416 12.3886 14.9057 12.1677C14.8198 12.1113 14.7496 12.0531 14.6577 11.9769C14.6051 11.9333 14.5454 11.8838 14.4717 11.8254C14.3 11.6894 14.0638 11.5184 13.7682 11.4302C13.3857 11.3161 13.0977 11.4484 12.9353 11.523L12.9243 11.528C12.7693 11.5991 12.6377 11.6646 12.5161 11.7252L12.516 11.7252C12.3142 11.8257 12.1398 11.9126 11.9313 11.9883C11.4539 12.1616 10.9526 12.1411 10.3509 12.0258C10.2037 11.9975 10.0101 11.8777 9.85069 11.6949C9.76373 11.5952 9.6821 11.4807 9.58988 11.344L9.5541 11.2906C9.82373 10.8253 10.0373 10.3108 10.1371 9.75679ZM7.86032 11.4598C7.93403 11.4598 7.99676 11.4613 8.05097 11.4647C8.02073 11.5019 7.99007 11.5388 7.95904 11.5754C7.46639 12.1568 6.89421 12.6721 6.27069 13.0172C5.7902 13.2832 5.33352 13.4513 4.87105 13.4617L4.85125 13.4621C4.87337 12.9858 5.21596 12.5335 5.72451 12.1767C6.36643 11.7264 7.12074 11.4598 7.86032 11.4598Z" fill="#1A1B1D" />
        </svg>
    )
}

const PlusIcon = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="28" height="28" rx="2" fill="#F1F3F5" />
            <path d="M14 17.75L14 10.25" stroke="#1A1B1D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.75 14H10.25" stroke="#1A1B1D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}